import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { withRouter } from 'components/withRouter';
import styles from './LobbyStyles.module.scss'
import { addToCart } from 'actions/cart';

// Lottie animations
import Lottie from 'react-lottie'

import timeWhite from 'animations/time-white.png'
import playersWhite from 'animations/minPlayers-white.png'

import timeBlack from 'animations/time-black.png'
import playersBlack from 'animations/minPlayers-black.png'
import { APP_TYPES } from '../../constants/AppTypes';


class GameMenu extends Component {
    static displayName = GameMenu.name;

    constructor(props) {
        super(props);

        this.state = {
            // game: {},
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.room.startingGame === true && prevProps.room.startingGame === false) {
            this.props.closeGameMenu();
        }
    }

    getStoreBackground() {
        var bg = this.props.game?.meta.gameMenuBackground;
        if (!bg) bg = this.props.game?.meta.storeBackground;
        return {
            backgroundImage: `url(${this.props.game?.meta.storeBackground})`,
            backgroundPosition: "center"
        }
    }

    getStoreAccentBorder() {
        return {
            backgroundColor: this.props.game?.meta.storeAccentColour,
            border: `10px solid ${this.props.game?.meta.storeAccentColour}`
        }
    }

    getStoreAccentBackground() {
        return {
            backgroundColor: this.props.game?.meta.storeAccentColour,
            border: `10px solid ${this.props.game?.meta.storeAccentColour}`
        }
    }

    getStoreAccentImageBorder() {
        if (this.props.game?.name === "Playing With Fire") {
            return {
                width: '85%',
                border: `10px solid #292d41`
            }
        } else {
            return {
                border: `4px solid ${this.props.game?.meta.storeAccentColour}`
            }
        }
        
    }

    getStoreInfoBackground() {
        return {
            backgroundColor: `${this.props.game?.meta.storeInfoBackground}`
        }
    }

    addGameToCart(game) {
        this.props.addToCart(game);
    }


    goToGame() {
        if (this.props.room.roomOpen) {
            console.log("Sending StartGame to room with gameId : ", this.props.game.gameId);
            this.props.room.room.send("StartGame", { gameId: this.props.game.gameId });
        }
    }

    playersAllConnected() {
        let allConnected = true;
        this.props.room.players.forEach((x) => {
            if (!x.connected) allConnected = false;
        });
        return allConnected;
    }

    getGameInfoBackground() {
        const meta = this.props.game?.meta;
        if (!meta) return {};

        const { infoBackgroundImage, infoBackgroundImagePixelated, gameMenuBackgroundColour } = meta;

        //if (infoBackgroundImage) {
        //    const style = { backgroundImage: `url(${infoBackgroundImage})` };
        //    if (infoBackgroundImagePixelated) {
        //        style.imageRendering = "pixelated";
        //    }
        //    return style;
        //}

        return { backgroundColor: gameMenuBackgroundColour };
    }

    getStoreCardLogoStyles() {
        if (this.props.game?.name === "Playing With Fire") {
            return {
                height: '10vh',
                objectFit: 'cover'
            }
        }
    }

    getAgeIcon() {
        return this.props.game?.meta.ageRatingIcon;
    }

    getStoreCardLogo() {
            return this.props.game?.meta.storeLogo
    }

    getUnsupportedText() {
        let text = [
            "This game is not supported on ",
            <span key="platform" style={{ textTransform: "capitalize" }}>
                {this.props.room.roomState.platform}
            </span>,
            ". Please play on one of the following platforms: "
        ];

        let platformCount = 0;
        for (let i = 0; i < this.props.game?.supportedPlatforms.length; i++) {
            let platform = this.props.game?.supportedPlatforms[i];
            let platformText = "";
            switch (platform) {
                case APP_TYPES.WEB:
                    platformText += "Web Browser";
                    break;
                case APP_TYPES.ROKU:
                    platformText += "Roku App";
                    break;
                case APP_TYPES.FIRE_TV:
                    platformText += "Fire TV App";
                    break;
                default:
                    break;
            }
            if (platformText.length > 0) {
                if (platformCount > 0) text.push(", ");
                platformCount += 1;
                text.push(platformText);
            }
        }

        text.push(".");
        return <p style={{ color: this.props.game?.meta.gameMenuTextColour, fontSize: "2.5vh", fontWeight: "bold", margin: "unset" }}>{text}</p>;
    }

    render() {
        return (
            <>
                {
                    !this.props.isMobile &&
                    <div className={`${styles.background}`} />
                }
                <div className={`${styles.gameMenu} ${this.props.isMobile && styles.mobile}`}>
                    {
                        this.props.isMobile &&
                        <div className={`${styles.background}`} />
                    }
                    <div className={styles.menu} style={this.getStoreBackground()}>
                        <img className={styles.gameLogo} src={this.getStoreCardLogo()} alt={`${this.props.game.name} Logo`} style={this.getStoreCardLogoStyles()} />
                        <br />
                        <img src={this.props.game?.meta.previewImages.desktop1} alt="" style={this.getStoreAccentImageBorder()} />
                        {
                            this.props.supported &&
                            <div className={styles.infoWrapper} style={this.getGameInfoBackground()}>
                                <div className={styles.gameDescription} style={{ color: this.props.game?.meta.gameMenuTextColour }}>
                                    {this.props.game.description}
                                </div>
                                <div className={styles.gameInfo} style={{ color: this.props.game?.meta.gameMenuTextColour }}>
                                    <ul className={styles.gameMetrics} >
                                        <li style={{ color: this.props.game?.meta.gameMenuTextColour }}>
                                            <img className={styles.icon} src={this.props.game?.meta.iconTheme === "light" ? timeWhite : timeBlack} alt="time" />
                                            <span>{this.props.game.gameInfo?.avgRoundLengthText}</span>
                                        </li>
                                        <li style={{ color: this.props.game?.meta.gameMenuTextColour }}>
                                            <img className={styles.icon} src={this.props.game?.meta.iconTheme === "light" ? playersWhite : playersBlack} alt="players" />
                                            <span>{this.props.game.gameInfo?.maxPlayers ? `${this.props.game.gameInfo?.minPlayers}-${this.props.game.gameInfo?.maxPlayers} Players` : `${this.props.game.gameInfo?.minPlayers}+ Players`}</span>
                                        </li>
                                        <li style={{ color: this.props.game?.meta.gameMenuTextColour }}>
                                            <img className={styles.icon} src={this.getAgeIcon()} style={{ paddingTop: "2%", paddingBottom: "2%" }} alt="age" />
                                            <span>
                                                Age {this.props.game.gameInfo?.minAge}+
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                                {this.props.game.licence &&
                                    <div className={styles.gameLicence} style={{ color: this.props.game?.meta.gameMenuTextColour }}>
                                        {this.props.game.licence}
                                    </div>
                                }
                            </div>
                        }
                        <br />
                        {
                            this.props.supported ? 
                                <>
                                    <div className={styles.buttonWrap}>
                                        <button onClick={() => this.props.closeGameMenu()} className={`${styles.button} ${styles.alternate}`}>Back</button>
                                        <button onClick={() => this.goToGame()} className={styles.button} disabled={this.props.room.players.length < this.props.game.gameInfo.minPlayers || !this.playersAllConnected()}>Start Game</button>

                                    </div>
                                    {
                                        this.props.room.players.length < this.props.game.gameInfo.minPlayers ?
                                            <div className={styles.infoWrapper} style={{ backgroundColor: this.props.game?.meta.gameMenuBackgroundColour, marginTop: "1vh", }}>
                                                <p style={{ color: this.props.game?.meta.gameMenuTextColour, fontSize: "2.5vh", fontWeight: "bold", margin: "unset" }}>Not enough players to start!</p>
                                            </div>
                                            :
                                            this.playersAllConnected() === false ?

                                                <div className={styles.infoWrapper} style={{ backgroundColor: this.props.game?.meta.gameMenuBackgroundColour, marginTop: "1vh", }}>
                                                    <p style={{ color: this.props.game?.meta.gameMenuTextColour, fontSize: "2.5vh", fontWeight: "bold", margin: "unset" }}>Not all players are connected!</p>
                                                </div>
                                                :
                                                null
                                    }
                                </>
                                :
                                <>
                                <div className={styles.infoWrapper} style={{ backgroundColor: this.props.game?.meta.gameMenuBackgroundColour, marginTop: "1vh", }}>
                                        {this.getUnsupportedText()}
                                    </div>
                                    <div className={`${styles.buttonWrap} mt-3`}>
                                        <button onClick={() => this.props.closeGameMenu()} className={`${styles.button} ${styles.alternate}`}>Back</button>
                                    </div>
                                </>
                        }
                        
                    </div>
                </div>
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToCart: (game) => {
            dispatch(addToCart(game))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GameMenu));
